<mat-grid-list cdkDropListGroup [cols]="groups.length">
    <mat-grid-tile *ngFor="let list of groups" class="drag-drop-group">
        <div class="dragList">
            <mat-list cdkDropList [cdkDropListData]="list" (cdkDropListDropped)="onCdkDropListDropped($event)" class="drag-drop-list">
                <ng-container *ngFor="let item of list">
                    <div cdkDrag class="drag-drop-item">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <forge-icon name="drag_indicator"></forge-icon>
                            <div fxLayout="column">
                                <div class="forge-typography--heading2">
                                    {{getDisplay(item)}}
                                </div>
                                <div class="forge-typography--subheading1">
                                    {{getSubtitle(item)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </mat-list>
        </div>
    </mat-grid-tile>
</mat-grid-list>
